export enum ExportType {
  UNSELECTED = 'Select an option',
  CSV = 'CSV',
  MARKDOWN = 'Markdown',
}
